import { createZustandContext } from '@/lib/store/zustand-context-pattern';
export type CFormSectionStore = {
  state: {
    sectionId: string;
  };
};

/**
 * CFormSection 内のコンポーネントから sectionId を取得するためのシンプルな Store
 */
export const {
  context: CFormSectionStore,
  useStore: useCFormSectionStore
} = createZustandContext<CFormSectionStore>(() => ({
  state: {
    sectionId: ''
  }
}));